// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/shunting_unit.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.model.ShuntingUnit
 */
export class ShuntingUnit extends Message<ShuntingUnit> {
  /**
   * @generated from field: string guid = 1;
   */
  guid = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: repeated knop.ui.v1.model.PlanTrainUnit plan_train_units = 3;
   */
  planTrainUnits: PlanTrainUnit[] = [];

  constructor(data?: PartialMessage<ShuntingUnit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.ShuntingUnit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "plan_train_units", kind: "message", T: PlanTrainUnit, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShuntingUnit {
    return new ShuntingUnit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShuntingUnit {
    return new ShuntingUnit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShuntingUnit {
    return new ShuntingUnit().fromJsonString(jsonString, options);
  }

  static equals(a: ShuntingUnit | PlainMessage<ShuntingUnit> | undefined, b: ShuntingUnit | PlainMessage<ShuntingUnit> | undefined): boolean {
    return proto3.util.equals(ShuntingUnit, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.model.PlanTrainUnit
 */
export class PlanTrainUnit extends Message<PlanTrainUnit> {
  /**
   * @generated from field: string guid = 1;
   */
  guid = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string type = 3;
   */
  type = "";

  /**
   * @generated from field: string kind = 4;
   */
  kind = "";

  /**
   * @generated from field: uint32 units = 5;
   */
  units = 0;

  /**
   * @generated from field: uint32 length_in_mm = 6;
   */
  lengthInMm = 0;

  /**
   * @generated from field: bool is_third_party = 7;
   */
  isThirdParty = false;

  constructor(data?: PartialMessage<PlanTrainUnit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.PlanTrainUnit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "units", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "length_in_mm", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "is_third_party", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlanTrainUnit {
    return new PlanTrainUnit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlanTrainUnit {
    return new PlanTrainUnit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlanTrainUnit {
    return new PlanTrainUnit().fromJsonString(jsonString, options);
  }

  static equals(a: PlanTrainUnit | PlainMessage<PlanTrainUnit> | undefined, b: PlanTrainUnit | PlainMessage<PlanTrainUnit> | undefined): boolean {
    return proto3.util.equals(PlanTrainUnit, a, b);
  }
}

